"use client";

import * as React from "react";
import { PopupInfo } from "components/PopupInfo/PopupInfo";
import { cn } from "@/lib/utils";
import { ProgressRing } from "../composites/progress-ring";
import { homeCardVariants } from "../foundations/home-variants";
import { HomeLoadingStateV2 } from "./HomeLoadingStateV2";

export interface HomeProgressCardV2Props {
  title: string;
  value: number;
  loading: boolean;
  popupInfo?: string;
}

export function HomeProgressCardV2({ title, value, loading, popupInfo }: HomeProgressCardV2Props) {
  return (
    <div className="relative">
      <div className={cn(homeCardVariants({ variant: "metric" }), "min-h-[90px] border-2 p-3")}>
        <div className="flex h-full flex-col items-center justify-center gap-2">
          {!loading ? <ProgressRing value={value} showValue /> : <HomeLoadingStateV2 inline compact />}
          <span className="text-xs text-slate-500 dark:text-zinc-400">{title}</span>
        </div>
      </div>
      {popupInfo && (
        <div className="absolute right-2 top-2">
          <PopupInfo className="ml-2 self-center" label={popupInfo} placement="bottomEnd" />
        </div>
      )}
    </div>
  );
}
